<template>
  <div class="relative w-full">
    <swiper :options="bookOption" class="swiper w-full pb-6 sm:pb-10">
      <swiper-slide v-for="(item, index) in indexBookData" :key="index" class="item cursor-pointer flex flex-col">
        <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="mb-2 md:mb-3 lg:mb-4 w-full" aria-label="Book">
          <div class="square-book" :style="{ 'background-color': bgColorList[index] }">
            <div v-if="item.cover !== ''" class="square-img book-shadow" v-lazy:background-image="{ src: item.cover }"></div>
            <div v-if="item.cover === ''" class="square-img square-img-none book-shadow"></div>
          </div>
        </router-link>
        <div class="swiper-text text-base text-center lg:text-left w-full">
          <p class="leading-snug p-0 mb-1 featuredBooks-name text-base textColorBlack whitespace-pre-wrap">{{ item.name }}</p>
          <div class="flex flex-wrap justify-center lg:justify-start">
            <p class="p-0 mb-0 line-through featuredBooks-price text-NotoSansRegular whitespace-no-wrap leading-relaxed">
              <span class="hidden lg:inline-block">原價</span>
              <span class="lg:hidden">NT.</span>
              {{ item.fixed_price }}
            </p>
            <p class="mx-1 sm:mx-2 featuredBooks-price leading-relaxed">|</p>
            <p class="featuredBooks-newprice leading-relaxed">NT.{{ item.pricing }}</p>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-next focus:outline-none cursor-pointer hidden sm:block swiper-button-next-book mt-0 swiper-button-next-index"></div>
    <div class="swiper-button-prev focus:outline-none cursor-pointer hidden sm:block swiper-button-prev-book mt-0 swiper-button-prev-index"></div>
  </div>
</template>

<script>
export default {
  props: {
    indexBookData: {
      type: Array
    },
    bgColorList: {
      type: Array
    }
  },
  data () {
    return {
      bookOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        watchOverflow: true,
        loop: false,
        autoplay: {
          delay: 5000
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            autoplay: {
              delay: 5000
            }
          }
        },
        navigation: {
          nextEl: '.swiper-button-next-book',
          prevEl: '.swiper-button-prev-book'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .slider-books {
    h3 {
      font-weight: 700;
    }
    .square-book {
      position: relative;
      // width: 100%;
      padding-bottom : 100%;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      .square-img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 75%;
        padding-bottom : 75%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url('~@/assets/images/preset_item.png');
      }
      .square-img[lazy=loading] {
        background-image: none !important;
      }
      .book-shadow {
        filter: drop-shadow(10px 10px 1px rgba(0, 0, 0, 0.4));
        @media (max-width: 1024px) {
          filter: drop-shadow(8px 8px 1px rgba(0, 0, 0, 0.4));
        }
        @media (max-width: 768px) {
          filter: drop-shadow(5px 5px 1px rgba(0, 0, 0, 0.4));
        }
      }
    }
    .swiper-text {
      .featuredBooks-name {
        min-height: 44px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
      }
      .featuredBooks-price {
        font-size: 14px;
        color: #434343;
      }
      .featuredBooks-newprice {
        font-size: 14px;
        color: #e60012;
      }
    }
  }
</style>
